<template>
  <b-form-group
    label="Banka"
    label-for="id_banks"
  >
    <validation-provider
      #default="{ errors }"
      name="Banka"
      rules="required"
    >
      <v-select
        id="id_banks"
        v-model="dataItem.id_banks"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Banka"
        :clearable="false"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'BinNo',
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['binsDefines/dataItem']
    },
    dataList() {
      return this.$store.getters['banks/getBanks']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('banks/banks')
    },
  },
}
</script>
